module.exports = __webpack_public_path__ + "img/cert_01.44ed4d14.jpg";